import { Player, createCompletePromocodeMutation } from 'shared/api';
import { ConfirmModalModel, createConfirmModalModel, declareModalData } from 'shared/lib';

export type CompletePromocodeModel = ConfirmModalModel<Player, { playerId: number }, Player>;

export const createCompletePromocodeModel = (): CompletePromocodeModel => {
	const completePromocodeMutation = createCompletePromocodeMutation();

	const model = createConfirmModalModel<Player, { playerId: number }, Player>({
		modalData: declareModalData<Player>(),
		mutation: completePromocodeMutation,
		mapModalData: ({ id }) => ({ playerId: id }),
		successMessageKey: 'complete-promocode.success',
	});

	return model;
};
